const FundingSources = () => {
  const container = '#funding-pie-chart';

  const data = [
    { type: 'taxes', value: 78 },
    { type: 'state park fees', value: 5 },
    { type: 'development fees', value: 6 },
    { type: 'wastewater surcharge', value: 4 },
    { type: 'other', value: 7 },
  ];

  const width = 500;
  const height = Math.min(width, 500);
  const radius = Math.min(width, height) / 2;

  const color = d3.scaleOrdinal(d3.schemeCategory10);

  const pie = d3.pie().value(d => d.value);

  const arc = d3
    .arc()
    .innerRadius(radius - 100)
    .outerRadius(radius - 20);

  const svg = d3
    .select(container)
    .append('svg')
    .attr('width', width)
    .attr('height', height)
    .style('margin-left', '8%')
    .append('g')
    .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');

  const path = svg
    .datum(data)
    .selectAll('path')
    .data(pie)
    .enter()
    .append('path')
    .attr('fill', (d, i) => color(i))
    .attr('d', arc)
    .each(function (d) {
      this._current = d;
    }); // store the initial angles

  const text = svg
    .selectAll('text')
    .data(pie)
    .enter()
    .append('text')
    .attr('transform', d => `translate(${arc.centroid(d)})`)
    .attr('dy', '0.35em');

  text
    .append('tspan')
    .attr('x', '-0.4em')
    .attr('y', 0)
    .style('font-weight', 'bold')
    .style('font-size', '1.4rem')
    .style('text-align', 'center')
    .style('fill', '#FFF')
    .text(d => `${d.data.value}%`);

  const legend = d3.select(container).append('div').attr('class', 'funding-legend');

  const legendItems = d3.select('.funding-legend').selectAll('.funding-legend-item').data(data);

  legendItems.enter().append('div').attr('class', 'funding-legend-item').style('margin-top', '25px');

  d3.selectAll('.funding-legend-item')
    .append('div')
    .attr('class', 'funding-legend-rect')
    .style('width', '40px')
    .style('height', '20px')
    .style('background-color', function (d, i) {
      return color(i);
    });

  d3.selectAll('.funding-legend-item')
    .append('div')
    .attr('class', 'funding-legend-text')
    .text(d => d.type);
};

const FundingSplit = () => {
  const container = '#funding-pie-chart';

  const data = [
    { type: 'Pollution Abatement Projects', value: 60 },
    { type: 'Special Projects', value: 40 },
  ];

  const width = 500;
  const height = Math.min(width, 500);
  const radius = Math.min(width, height) / 2;

  const color = d3.scaleOrdinal(d3.schemeCategory10);

  const pie = d3.pie().value(d => d.value);

  const arc = d3
    .arc()
    .innerRadius(radius - 100)
    .outerRadius(radius - 20);

  const svg = d3
    .select(container)
    .append('svg')
    .attr('width', width)
    .attr('height', height)
    .style('margin-left', '8%')
    .append('g')
    .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');

  const path = svg
    .datum(data)
    .selectAll('path')
    .data(pie)
    .enter()
    .append('path')
    .attr('fill', (d, i) => color(i))
    .attr('d', arc)
    .each(function (d) {
      this._current = d;
    }); // store the initial angles

  const text = svg
    .selectAll('text')
    .data(pie)
    .enter()
    .append('text')
    .attr('transform', d => `translate(${arc.centroid(d)})`)
    .attr('dy', '0.35em');

  text
    .append('tspan')
    .attr('x', '-0.4em')
    .attr('y', 0)
    .style('font-weight', 'bold')
    .style('font-size', '1.4rem')
    .style('text-align', 'center')
    .style('fill', '#FFF')
    .text(d => `${d.data.value}%`);

  const legend = d3.select(container).append('div').attr('class', 'funding-legend');

  const legendItems = d3.select('.funding-legend').selectAll('.funding-legend-item').data(data);

  legendItems.enter().append('div').attr('class', 'funding-legend-item').style('margin-top', '25px');

  d3.selectAll('.funding-legend-item')
    .append('div')
    .attr('class', 'funding-legend-rect')
    .style('width', '40px')
    .style('height', '20px')
    .style('background-color', function (d, i) {
      return color(i);
    });

  d3.selectAll('.funding-legend-item')
    .append('div')
    .attr('class', 'funding-legend-text')
    .text(d => d.type);
};

const CIPTable = () => {
  const CIPData = [
    {
      'Project Title': 'East Shade Shelter Shoreline Stabilization Phase III',
      'Total': '$975',
      'Authority Portion': '$842',
      'Proposed 2024 Budget': '$658',
      'Out-year Budget': '$658',
      'Funding Year(s)': '2021-2024'
    },
    {
      'Project Title': 'Tower Loop Shoreline Stabilization Phase II',
      'Total': '$1,035',
      'Authority Portion': '$1,035',
      'Proposed 2024 Budget': '$ -',
      'Out-year Budget': '$1,035',
      'Funding Year(s)': '2021-2024'
    },
    {
      'Project Title': 'Cherry Creek Stream Reclamation at Main Street (Parker)',
      'Total': '$5,600',
      'Authority Portion': '$1,280',
      'Proposed 2024 Budget': '$ -',
      'Out-year Budget': '$1,280',
      'Funding Year(s)': '2027-2028'
    },
    {
      'Project Title': 'Cherry Creek Stream Stabilization at Lincoln Avenue (Parker)',
      'Total': '$3,290',
      'Authority Portion': '$755',
      'Proposed 2024 Budget': '$ -',
      'Out-year Budget': '$755',
      'Funding Year(s)': '2030-2031'
    },
    {
      'Project Title': 'Cherry Creek Stream Reclamation at Arapahoe Rd. - Valley Country Club to Soccer Fields, Reaches 3 to 4',
      'Total': '$10,600',
      'Authority Portion': '$1,655',
      'Proposed 2024 Budget': '$300',
      'Out-year Budget': '$1,104',
      'Funding Year(s)': '2021-2031'
    },
    {
      'Project Title': 'Cherry Creek - Reservoir to Lake View Drive Alternatives Analysis and Development of Preferred Alternative',
      'Total': '$438',
      'Authority Portion': '$438',
      'Proposed 2024 Budget': '$181',
      'Out-year Budget': '$181',
      'Funding Year(s)': '2023-2024'
    },
    {
      'Project Title': 'Cherry Creek all Reaches in CCSP*',
      'Total': '$30,488',
      'Authority Portion': '$ -',
      'Proposed 2024 Budget': '$ -',
      'Out-year Budget': '$7,650',
      'Funding Year(s)': '2025-2033'
    },
    {
      'Project Title': 'Piney Creek - Cherry Creek to Parker Road, Reaches 1 to 2 (SEMSWA)',
      'Total': '$4,060',
      'Authority Portion': '$930',
      'Proposed 2024 Budget': '$39',
      'Out-year Budget': '$829',
      'Funding Year(s)': '2022-2032'
    },
    {
      'Project Title': 'Piney Creek south of Orchard Rd., Reaches 4 to 5 (SEMSWA)',
      'Total': '$5,320',
      'Authority Portion': '$1,220',
      'Proposed 2024 Budget': '$75',
      'Out-year Budget': '$1,220',
      'Funding Year(s)': '2024-2029'
    },
    {
      'Project Title': 'McMurdo Gulch Reclamation (Castle Rock)',
      'Total': '$5,162',
      'Authority Portion': '$1,292',
      'Proposed 2024 Budget': '$1,121',
      'Out-year Budget': '$1,121',
      'Funding Year(s)': '2022-2024'
    },
    {
      'Project Title': 'Cottonwood Creek Tributary - Shooting Area Tributary (CCSP)',
      'Total': '$720',
      'Authority Portion': '$180',
      'Proposed 2024 Budget': '$ -',
      'Out-year Budget': '$180',
      'Funding Year(s)': '2028'
    },
    {
      'Project Title': 'Cottonwood Creek and Tributary C (IWSD)',
      'Total': '$2,496',
      'Authority Portion': '$624',
      'Proposed 2024 Budget': '$ -',
      'Out-year Budget': '$624',
      'Funding Year(s)': '2030'
    },
    {
      'Project Title': 'Lone Tree Creek in CCSP downstream of Pond (CCBWQA Only)',
      'Total': '$600',
      'Authority Portion': '$600',
      'Proposed 2024 Budget': '$120',
      'Out-year Budget': '$600',
      'Funding Year(s)': '2024-2025'
    },
    {
      'Project Title': 'Lone Tree Creek in CCSP upstream of Pond (Centennial Trail Portion)',
      'Total': '$448',
      'Authority Portion': '$112',
      'Proposed 2024 Budget': '$112',
      'Out-year Budget': '$112',
      'Funding Year(s)': '2024'
    },
    {
      'Project Title': 'Happy Canyon Creek at Jordan Road (SEMSWA)',
      'Total': '$6,300',
      'Authority Portion': '$1,445',
      'Proposed 2024 Budget': '$50',
      'Out-year Budget': '$1,264',
      'Funding Year(s)': '2021-2023'
    },
    {
      'Project Title': 'PRF Preservation, Acquisition, Lease of Land or Water',
      'Total': '$1,000',
      'Authority Portion': '$1,000',
      'Proposed 2024 Budget': '$100',
      'Out-year Budget': '$1,000',
      'Funding Year(s)': '2024-2033'
    },
    {
      'Project Title': 'Total Capital Projects',
      'Total': '$78,532',
      'Authority Portion': '$13,408',
      'Proposed 2024 Budget': '$2,756',
      'Out-year Budget': '$19,613',
      'Funding Year(s)': ''
    },
    {
      'Project Title': 'Routine',
      'Total': '$598',
      'Authority Portion': '$593',
      'Proposed 2024 Budget': '$63',
      'Out-year Budget': '$603',
      'Funding Year(s)': '2024-2033'
    },
    {
      'Project Title': 'Operations',
      'Total': '$922',
      'Authority Portion': '$922',
      'Proposed 2024 Budget': '$88',
      'Out-year Budget': '$922',
      'Funding Year(s)': '2024-2033'
    },
    {
      'Project Title': 'Restorative',
      'Total': '$2,888',
      'Authority Portion': '$2,888',
      'Proposed 2024 Budget': '$243',
      'Out-year Budget': '$2,898',
      'Funding Year(s)': '2024-2033'
    },
    {
      'Project Title': 'Rehabilitation',
      'Total': '$0',
      'Authority Portion': '$0',
      'Proposed 2024 Budget': '$0',
      'Out-year Budget': '$0',
      'Funding Year(s)': '2024-2033'
    },
    {
      'Project Title': 'Total Operations & Maintenance',
      'Total': '$4,408',
      'Authority Portion': '$4,403',
      'Proposed 2024 Budget': '$394',
      'Out-year Budget': '$4,423',
      'Funding Year(s)': '2024-2033'
    },
    {
      'Project Title': 'Total',
      'Total': '$82,940',
      'Authority Portion': '$17,811',
      'Proposed 2024 Budget': '$3,150',
      'Out-year Budget': '$24,036',
      'Funding Year(s)': '2024-2033'
    }
  ];

  // Declare and configure request overview table
  const table = new requestTable({
    container: '#cip-table',
    filterEnabled: false,
    tableHeaders: {
      'Project Title': 'Project Title',
      Total: 'Current Total Budget',
      'Authority Portion': 'Current Authority Portion',
      'Proposed 2024 Budget': 'Proposed 2024 Budget',
      'Out-year Budget': 'Out-year Budget',
      'Funding Year(s)': 'Funding Year(s)',
    },
    tableActions: [],
    tableData: CIPData,
  });
  table.buildTable();
};
